<div class="randomize-container">
    <div class="randomize-contnent">
        <p *ngIf="caption" class="dfont center">{{caption}}</p>

        <div [ngClass]="['window', mode]">
            <div *ngFor="let text of data; let i = index"
                class="text"
                [ngClass]="isOpenned(i)? 'showed' : 'hidden'">            
                {{text}}
            </div>
        </div>
    </div>
    <div class="randomize-buttons">
        <button class="dark" *ngIf="mode === 'rotating'" (click)="onRandomizeClick()">Losuj</button>
        <button class="dark" *ngIf="mode === 'stale'" (click)="onResetClick()">Jeszcze raz</button>
    </div> 
</div>